/*
 * SafeWall product page (sections/sw-product-main.liquid).
 * - Design cards (variant radios): update URL ?variant=, headline, breadcrumb, description, prices
 *   per sq ft, gallery, calculator subtotal, sample variant and the add button state.
 * - Box calculator: the larger of two counts, so tall walls get enough rolls (each box is one roll
 *   and strips can't be joined):
 *   area:   ceil(width × height × walls × (1.10 if extra) / sq ft per box)
 *   strips: ceil(walls × ceil(width / (roll width − overlap)) / floor(roll length / height))
 *   Every change sets the quantity to the estimate. Invalid input, or a wall taller than a roll, shows
 *   "–" and leaves the quantity alone.
 * - Add to cart: final sale checkbox required (when there is one); POST /cart/add.js with the line
 *   item properties (+ Grounding Kit when ticked; a sold-out kit shows a message instead), then Rebuy
 *   Smart Cart or /cart. Errors show under the button.
 * - Gallery: thumbnails on wider screens; on phones, bullets on the image (built from the visible
 *   thumbnails) and swiping.
 * - Also runs the simple SafeWall product page (sections/sw-product-simple.liquid): no calculator, no
 *   final sale checkbox, and data-price-mode="item" shows the variant price instead of the price per
 *   sq ft.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.hasAttribute('data-pdp-ready')) return;
    var dataEl = root.querySelector('[data-pdp-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.setAttribute('data-pdp-ready', '');

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var moneyFormat = (root.getAttribute('data-money-format') || '${{amount}}').replace(/<[^>]*>/g, '');
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var allowPurchase = root.getAttribute('data-allow-purchase') === 'true';
    var perItem = root.getAttribute('data-price-mode') === 'item';
    var sqft = parseFloat(data.sqft) > 0 ? parseFloat(data.sqft) : 30.75;
    var rollWidth = parseFloat(data.rollWidth) > 0 ? parseFloat(data.rollWidth) : 20.5;
    var rollLength = parseFloat(data.rollLength) > 0 ? parseFloat(data.rollLength) : 18;
    var overlap = parseFloat(data.overlap) >= 0 ? parseFloat(data.overlap) : 1;
    var variants = data.variants || [];
    var samples = data.samples || [];
    var props = data.props || {};

    var form = q('.sw-product-main__form');
    var radios = qa('input[type="radio"][name="id"]');
    var els = {
      title: q('[data-pdp-title]'),
      crumb: q('[data-pdp-crumb]'),
      designName: q('[data-pdp-design-name]'),
      desc: q('[data-pdp-desc]'),
      price: q('[data-pdp-price]'),
      compare: q('[data-pdp-compare]'),
      badge: q('[data-pdp-badge]'),
      estimate: q('[data-pdp-estimate]'),
      subtotal: q('[data-pdp-subtotal]'),
      qty: q('[data-pdp-qty]'),
      submit: q('[data-pdp-submit]'),
      ack: q('[data-pdp-ack]'),
      error: q('[data-pdp-error]'),
      kit: q('[data-pdp-kit]'),
      sampleBtn: q('[data-pdp-sample-btn]'),
      sampleLink: q('[data-pdp-sample-link]'),
      sampleForm: q('[data-pdp-sample-form]'),
      sampleId: q('[data-pdp-sample-id]'),
      sampleError: q('[data-pdp-sample-error]'),
      sampleThumb: q('[data-pdp-sample-thumb]'),
      width: q('[data-calc-width]'),
      height: q('[data-calc-height]'),
      walls: q('[data-calc-walls]'),
      waste: q('[data-calc-waste]')
    };

    var busy = false;
    // Pages without the final sale checkbox count as acknowledged
    function acknowledged() { return !els.ack || els.ack.checked; }

    function findVariant(id) {
      id = Number(id);
      for (var i = 0; i < variants.length; i++) if (Number(variants[i].id) === id) return variants[i];
      return null;
    }
    var checked = radios.filter(function (r) { return r.checked; })[0];
    var current = (checked && findVariant(checked.value)) || variants[0] || null;

    /* ---------- Money ---------- */
    function formatMoney(cents, trimZeros) {
      cents = Math.round(Number(cents) || 0);
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = match ? match[1] : 'amount';
      var map = {
        amount: [2, ',', '.'],
        amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','],
        amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_space_separator: [2, ' ', ','],
        amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_period_and_space_separator: [2, ' ', '.'],
        amount_with_apostrophe_separator: [2, "'", '.']
      };
      var o = map[key] || map.amount;
      var precision = trimZeros && cents % 100 === 0 ? 0 : o[0];
      var parts = (cents / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, o[1]);
      var value = parts.join(o[2]);
      return match ? moneyFormat.replace(match[0], value) : value;
    }

    /* ---------- Errors ---------- */
    function showError(el, msg) {
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }
    function hideError(el) {
      if (!el) return;
      el.textContent = '';
      el.hidden = true;
    }

    /* ---------- Add button state ---------- */
    function updateButton() {
      var btn = els.submit;
      if (!btn) return;
      var available = !!(current && current.available);
      // Before launch (Allow purchase off) the button keeps its label even while sold out
      var label = available || !allowPurchase ? btn.getAttribute('data-label') : btn.getAttribute('data-sold-out');
      if (label && btn.textContent !== label) btn.textContent = label;
      btn.disabled = busy || !allowPurchase || !available || !acknowledged();
      // 50% while the final sale checkbox is unticked
      btn.classList.toggle('is-unacknowledged', !acknowledged());
    }

    /* ---------- Calculator ---------- */
    function readPositive(input) {
      if (!input) return NaN;
      var v = parseFloat(String(input.value).replace(',', '.'));
      return isFinite(v) && v > 0 ? v : NaN;
    }
    function calc(setQty) {
      var w = readPositive(els.width);
      var h = readPositive(els.height);
      var n = readPositive(els.walls);
      if (!(w > 0) || !(h > 0) || !(n >= 1) || Math.floor(n) !== n) {
        if (els.estimate) els.estimate.textContent = '–';
        if (els.subtotal) els.subtotal.textContent = '–';
        return;
      }
      var stripsPerRoll = Math.floor(rollLength / h + 1e-9);
      var stripFeet = (rollWidth - overlap) / 12;
      if (stripsPerRoll < 1 || !(stripFeet > 0)) {
        if (els.estimate) els.estimate.textContent = '–';
        if (els.subtotal) els.subtotal.textContent = '–';
        return;
      }
      var area = w * h * n * (els.waste && els.waste.checked ? 1.1 : 1);
      var areaBoxes = Math.ceil(area / sqft - 1e-9);
      var strips = n * Math.ceil(w / stripFeet - 1e-9);
      var stripBoxes = Math.ceil(strips / stripsPerRoll - 1e-9);
      var boxes = Math.max(1, areaBoxes, stripBoxes);
      if (els.estimate) els.estimate.textContent = String(boxes);
      if (els.subtotal) els.subtotal.textContent = current ? formatMoney(boxes * current.price, true) : '–';
      if (setQty && els.qty) els.qty.value = boxes;
    }

    /* ---------- Steppers ---------- */
    qa('[data-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      stepper.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-step]');
        if (!btn || !input) return;
        var v = parseInt(input.value, 10);
        if (!(v >= 1)) v = 1;
        v = Math.max(1, v + Number(btn.getAttribute('data-step')));
        input.value = v;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    [els.width, els.height, els.walls, els.waste].forEach(function (input) {
      if (!input) return;
      input.addEventListener(input.type === 'checkbox' ? 'change' : 'input', function () { calc(true); });
      // Enter in a calculator field must not submit the product form
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    });
    if (els.walls) {
      els.walls.addEventListener('change', function () {
        var v = parseInt(els.walls.value, 10);
        if (els.walls.value !== '' && !(v >= 1)) { els.walls.value = 1; calc(true); }
      });
    }
    if (els.qty) {
      els.qty.addEventListener('change', function () {
        var v = parseInt(els.qty.value, 10);
        els.qty.value = v >= 1 ? v : 1;
      });
    }

    /* ---------- Gallery ---------- */
    function showMedia(id) {
      id = String(id);
      var slides = qa('[data-media-id]');
      if (!slides.some(function (s) { return s.getAttribute('data-media-id') === id; })) return;
      slides.forEach(function (s) {
        var on = s.getAttribute('data-media-id') === id;
        s.hidden = !on;
        if (!on) s.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      });
      qa('[data-thumb], [data-dot]').forEach(function (t) {
        var on = (t.getAttribute('data-thumb') || t.getAttribute('data-dot')) === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    qa('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    // Phones: one bullet per visible thumbnail, on the image (CSS shows them below 750px)
    var dots = q('[data-pdp-dots]');
    var thumbs = qa('[data-thumb]');
    if (dots && thumbs.length > 1) {
      thumbs.forEach(function (t, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'sw-product-main__dot';
        d.setAttribute('data-dot', t.getAttribute('data-thumb'));
        d.setAttribute('aria-label', 'Show image ' + (i + 1));
        d.setAttribute('aria-current', t.classList.contains('is-active') ? 'true' : 'false');
        if (t.classList.contains('is-active')) d.classList.add('is-active');
        d.addEventListener('click', function () { showMedia(d.getAttribute('data-dot')); });
        dots.appendChild(d);
      });
      dots.hidden = false;
      syncDots();
    }
    function syncDots() {
      qa('[data-dot]').forEach(function (d) {
        var t = q('[data-thumb="' + d.getAttribute('data-dot') + '"]');
        d.hidden = !t || t.hidden;
      });
    }
    function visibleMedia() {
      return thumbs.filter(function (t) { return !t.hidden; }).map(function (t) { return t.getAttribute('data-thumb'); });
    }
    // Swipe left / right on the image (touch only, so desktop clicks and scrolling are untouched)
    var stage = q('.sw-product-main__stage');
    if (stage && thumbs.length > 1) {
      var x0 = null;
      var y0 = null;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var ids = visibleMedia();
        var active = q('[data-thumb].is-active');
        var i = ids.indexOf(active ? active.getAttribute('data-thumb') : '');
        var next = ids[(i + (dx < 0 ? 1 : -1) + ids.length) % ids.length];
        if (next) showMedia(next);
      }, { passive: true });
    }

    /* ---------- Sample ---------- */
    function pickSample(design) {
      var key = String(design || '').trim().toLowerCase();
      var match = null;
      var first = null;
      samples.forEach(function (s) {
        if (!s.available) return;
        if (!first) first = s;
        if (!match && (s.options || []).some(function (o) { return String(o).trim().toLowerCase() === key; })) match = s;
      });
      return match || first;
    }
    function updateSample() {
      if (els.sampleThumb && current && current.img) {
        var img = els.sampleThumb.querySelector('img');
        if (img && img.getAttribute('src') !== current.img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = current.img;
        }
      }
      if (els.sampleLink) {
        // Sample page link: the sample with the selected design, sold out or not
        var base = els.sampleLink.getAttribute('data-base') || els.sampleLink.getAttribute('href');
        var key = String((current && current.design) || '').trim().toLowerCase();
        var linked = samples.filter(function (s) {
          return (s.options || []).some(function (o) { return String(o).trim().toLowerCase() === key; });
        })[0];
        els.sampleLink.setAttribute('href', linked ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + linked.id : base);
      }
      if (!els.sampleBtn || !els.sampleId) return;
      var sv = pickSample(current && current.design);
      if (sv) els.sampleId.value = sv.id;
      els.sampleBtn.disabled = !sv;
    }

    /* ---------- Variant change ---------- */
    function setVariant(v, updateUrl) {
      if (!v) return;
      current = v;
      if (els.title) els.title.textContent = v.design;
      if (els.crumb) els.crumb.textContent = v.design;
      if (els.designName) els.designName.textContent = v.design;
      if (els.desc && typeof v.desc === 'string') els.desc.innerHTML = v.desc;

      var divisor = perItem ? 1 : sqft;
      if (els.price) els.price.textContent = formatMoney(Math.round(v.price / divisor));
      var hasCompare = Number(v.compare) > Number(v.price);
      if (els.compare) {
        els.compare.hidden = !hasCompare;
        els.compare.textContent = hasCompare ? formatMoney(Math.round(v.compare / divisor)) : '';
      }
      if (els.badge) {
        els.badge.hidden = !hasCompare;
        els.badge.textContent = hasCompare
          ? Math.round(((v.compare - v.price) * 100) / v.compare) + '% ' + (els.badge.getAttribute('data-suffix') || '')
          : '';
      }

      if (v.media) {
        // Only the selected design's own photo is listed next to the shared photos
        qa('[data-variant-thumb]').forEach(function (t) { t.hidden = t.getAttribute('data-thumb') !== String(v.media); });
        syncDots();
        showMedia(v.media);
      }

      radios.forEach(function (r) {
        var on = Number(r.value) === Number(v.id);
        r.checked = on;
        var card = r.closest('.sw-product-main__swatch');
        if (card) card.classList.toggle('is-selected', on);
      });

      if (updateUrl && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      }

      updateSample();
      calc(false);
      hideError(els.error);
      updateButton();
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) setVariant(findVariant(r.value), true);
      });
    });

    /* ---------- Cart ---------- */
    function openCart() {
      try {
        var R = window.Rebuy;
        if (R && R.Cart && R.SmartCart) {
          return Promise.resolve(R.Cart.fetchCart())
            .then(function () { R.SmartCart.show(); })
            .catch(function () { window.location.href = cartUrl; });
        }
      } catch (e) { /* fall through to the cart page */ }
      window.location.href = cartUrl;
      return Promise.resolve();
    }

    function addToCart(items, btn, errorEl) {
      busy = true;
      hideError(errorEl);
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (json) {
            if (!res.ok || json.status) {
              throw new Error(json.description || json.message || 'Could not add to cart. Please try again.');
            }
            return json;
          });
        })
        .then(function () {
          // Lets the SafeWall header update its cart count
          document.dispatchEvent(new CustomEvent('sw:cart-updated'));
          return openCart();
        })
        .catch(function (err) {
          showError(errorEl, (err && err.message) || 'Could not add to cart. Please try again.');
        })
        .then(function () {
          busy = false;
          if (btn) btn.removeAttribute('aria-busy');
          updateButton();
          updateSample();
        });
    }

    function addBoxes(e) {
        if (e) e.preventDefault();
        if (busy) return;
        if (!acknowledged()) {
          showError(els.error, data.ackMessage || 'Required to add to cart');
          els.ack.focus();
          return;
        }
        if (!allowPurchase || !current || !current.available) return;

        var qty = parseInt(els.qty && els.qty.value, 10);
        if (!(qty >= 1)) qty = 1;
        var properties = {};
        if (props.preorderKey && props.preorderValue) properties[props.preorderKey] = props.preorderValue;
        if (els.ack) properties[props.finalKey || 'Final sale'] = props.finalValue || els.ack.value;

        var items = [{ id: Number(current.id), quantity: qty, properties: properties }];
        if (els.kit && els.kit.checked && els.kit.getAttribute('data-variant-id')) {
          // A sold-out kit would make Shopify reject the whole add, boxes included
          if (els.kit.getAttribute('data-available') === 'false') {
            showError(els.error, els.kit.getAttribute('data-sold-out') || 'The Grounding Kit is sold out right now. Untick it to add the boxes.');
            return;
          }
          items.push({ id: Number(els.kit.getAttribute('data-variant-id')), quantity: 1 });
        }
        addToCart(items, els.submit, els.error);
    }
    if (form) form.addEventListener('submit', addBoxes);
    if (els.submit) els.submit.addEventListener('click', addBoxes);

    if (els.kit) els.kit.addEventListener('change', function () { hideError(els.error); });

    if (els.ack) {
      els.ack.addEventListener('change', function () {
        if (els.ack.checked) hideError(els.error);
        updateButton();
      });
    }

    function addSample(e) {
      if (e) e.preventDefault();
      if (busy || !els.sampleId || !els.sampleId.value) return;
      addToCart([{ id: Number(els.sampleId.value), quantity: 1 }], els.sampleBtn, els.sampleError);
    }
    if (els.sampleForm) els.sampleForm.addEventListener('submit', addSample);
    if (els.sampleBtn) els.sampleBtn.addEventListener('click', addSample);

    /* ---------- Initial state ---------- */
    if (current) setVariant(current, false);
  }

  function initAll() {
    document.querySelectorAll('.sw-product-main').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('.sw-product-main');
    if (el) init(el);
  });
})();
